import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * 智慧生成 Google Maps URL
 * @param mapUrl 現有的地圖 URL（如果已設定）
 * @param venueName 地點名稱
 * @param address 地址
 * @returns 有效的 Google Maps URL
 */
export function generateMapUrl(mapUrl?: string, venueName?: string, address?: string): string {
  // 如果已經有有效的地圖 URL，直接使用
  if (mapUrl && mapUrl !== 'https://maps.google.com' && mapUrl.trim() !== '') {
    return mapUrl;
  }
  
  // 構建搜尋字串
  const searchTerms: string[] = [];
  
  if (venueName && venueName.trim() !== '') {
    searchTerms.push(venueName.trim());
  }
  
  if (address && address.trim() !== '') {
    searchTerms.push(address.trim());
  }
  
  // 如果沒有任何有效資訊，返回 Google Maps 首頁
  if (searchTerms.length === 0) {
    return 'https://maps.google.com';
  }
  
  // 組合搜尋字串並進行 URL 編碼
  const searchQuery = searchTerms.join(' ');
  const encodedQuery = encodeURIComponent(searchQuery);
  
  // 生成 Google Maps 搜尋 URL
  return `https://maps.google.com/maps?q=${encodedQuery}`;
}

const WEEKDAY_NAMES = ['日', '一', '二', '三', '四', '五', '六'] as const;

export function formatChineseDate(dateStr: string): string {
  const date = new Date(dateStr + 'T00:00:00');
  if (isNaN(date.getTime())) return dateStr;
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  const d = date.getDate();
  const w = WEEKDAY_NAMES[date.getDay()];
  return `${y} 年 ${m} 月 ${d} 日（${w}）`;
}

export function hexToRgbChannels(hex: string): string {
  const cleaned = hex.replace('#', '');
  const r = parseInt(cleaned.substring(0, 2), 16);
  const g = parseInt(cleaned.substring(2, 4), 16);
  const b = parseInt(cleaned.substring(4, 6), 16);
  return `${r} ${g} ${b}`;
}